<script>
/**
 * 初期化する物だけがこれを読み込む ※ 一つのページに一つだけ存在
 */
export default {
	mixins: [
		require('js/common/vuex/setting/read.mixin.vue'),
	],
	methods: {
		setSettingParam: function(param){
			this.$store.commit("setting_set_param",param);
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/vuex/setting/write.mixin.vue